import { omit, flatten } from 'lodash'
import { getColumns } from './tables'
import { ReportSection, DataSection } from '../types'

export function getFlatSubReportSections(reportSection: ReportSection): ReportSection[] {
  return flatten(
    reportSection.dataSections.map((dataSection) => dataSection.subReportSections || []),
  )
}

export function flattenReportSections(reportSections: ReportSection[]): ReportSection[] {
  const finalSections: any[] = []

  reportSections.forEach((section) => {
    const withoutSubsections = {
      ...section,
      dataSections: section.dataSections.map((dataSection) =>
        omit(dataSection, 'subReportSections'),
      ),
    }

    finalSections.push(withoutSubsections)

    const subReportSections = getFlatSubReportSections(section)

    finalSections.push(...flattenReportSections(subReportSections))
  })

  return finalSections
}

// generate columns for data sections early because in-app tables and exports are using them
export function addReportSectionCols(reportSections: ReportSection[]): ReportSection[] {
  return reportSections.map((reportSection) => {
    const dataSections = reportSection.dataSections.map((dataSection: any) => {
      const finalDataSection: DataSection = { ...dataSection }

      const { data, columns, mergeColumns } = dataSection

      finalDataSection.columns = data
        ? getColumns({
            dataObj: data[0],
            columns,
            mergeCols: mergeColumns,
          })
        : []

      if (dataSection.subReportSections) {
        finalDataSection.subReportSections = addReportSectionCols(dataSection.subReportSections)
      }

      return finalDataSection
    })

    return { ...reportSection, dataSections }
  })
}
